import React from 'react';
import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { setDomain, deleteDomain } from '@/redux/actions';

const WS_EVENTS_BY_HTTP = {
	DELETE: 'client/:clientID/domain/:domainID/DELETE',
	CREATE: 'client/:clientID/domain/POST',
	UPDATE: 'client/:clientID/domain/:domainID/PATCH',
};

const DomainSubscriptions = props => {
	const { socket, deleteDomain, history, setDomain, currentClient, children } = props;
	const { clientID: id } = useParams();
	const navigate = useNavigate();
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribe = () => {
		socket.emit('client/:clientID/domain/SUBSCRIBE', { clientID: currentClient.id });
	};

	const unsubscribe = () => {
		socket.emit('client/:clientID/domain/UNSUBSCRIBE', { clientID: currentClient.id });
	};

	const listenForCreatedDomain = () =>
		socket.on(WS_EVENTS_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) {
				displayMessage('Domain could not be created', error);
			} else {
				displayMessage('Domain created');
				setDomain(data);
				// note: this works because we don't expect a lot of people to be making domains for the same client
				// at the same time. It will bring anyone on the domain page to the domain details on creation.
				// we can prevent this in the future by knowing WHO created the domain.
				navigate(`/clients/${currentClient.id}/branding/${data.id}`);
			}
		});

	const listenForUpdatedDomain = () =>
		socket.on(WS_EVENTS_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) {
				displayMessage('Error updating domain', error);
			} else {
				displayMessage('Domain updated');
				setDomain(data);
			}
		});

	const listenForDeletedDomain = () =>
		socket.on(WS_EVENTS_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) {
				displayMessage('Error deleting domain');
			} else {
				const { domainID, clientID } = data;
				if (parseInt(id) === domainID) history.push(`/clients/${clientID}`);
				displayMessage('Domain deleted');
				deleteDomain(data);
			}
		});

	const listeners = () => [listenForCreatedDomain, listenForDeletedDomain, listenForUpdatedDomain];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribe}
				unsub={unsubscribe}
				listeners={listeners()}
				routes={Object.values(WS_EVENTS_BY_HTTP)}
				from="DomainSubscriptions"
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};
const msp = ({ ws, clients }) => ({
	socket: ws.socket,
	currentClient: clients.currentClient,
});

const mdp = dispatch => ({
	setDomain: domain => dispatch(setDomain(domain)),
	deleteDomain: domainIDClientID => dispatch(deleteDomain(domainIDClientID)),
});

export default connect(msp, mdp)(DomainSubscriptions);
